import Paper from "@mui/material/Paper";
import { IAvailabilities } from "../../../../@types/resource.type";
import styles from "./styles.module.scss";

interface AvailabilityProps {
  isClickable: boolean;
  availabilities: IAvailabilities[];
  weekHours: number;
  onOpenModal?: () => void;
}

const weekDays: Record<number, string> = {
  0: "Dom",
  1: "Seg",
  2: "Ter",
  3: "Qua",
  4: "Qui",
  5: "Sex",
  6: "Sab",
};

export const Availability: React.FC<AvailabilityProps> = ({
  isClickable,
  availabilities,
  weekHours,
  onOpenModal,
}) => {
  const allWeekDays = Array.from({ length: 7 }, (_, i) => i);

  return (
    <div>
      {availabilities?.length >= 0 && (
        <Paper
          className={
            isClickable ? styles.clickablePaper : styles.noClickablePaper
          }
          onClick={isClickable ? onOpenModal : undefined}
          elevation={3}
        >
          <div className={styles.textHours}>Horas Disponíveis</div>
          <div className={styles.textWeek}>{weekHours}h Por Semana</div>

          {allWeekDays.map((day) => {
            const availability = availabilities.find(
              ({ dayOfWeek }) => dayOfWeek === day
            );

            const {
              totalTime = 0,
              startTime1 = null,
              endTime1 = null,
              startTime2 = null,
              endTime2 = null,
            } = availability || {};

            return (
              <div key={day} className={styles.dayOfWeek}>
                <div className={styles.dayAndHoursPerWeek}>
                  <div style={{ width: "3.125rem", fontWeight: "bold" }}>
                    {weekDays[day]}
                  </div>

                  <div style={{ width: "1.25rem", marginRight: "1.25rem" }}>
                    <span>{totalTime}h</span>
                  </div>
                </div>
                <div className={styles.papersContainer}>
                  {totalTime === 0 || totalTime === null ? (
                    <Paper className={styles.paper}>Indisponível</Paper>
                  ) : (
                    <>
                      {startTime1 && endTime1 && (
                        <Paper className={styles.paper}>
                          {startTime1} - {endTime1}
                        </Paper>
                      )}
                      {startTime2 && endTime2 && (
                        <Paper className={styles.paper}>
                          {startTime2} - {endTime2}
                        </Paper>
                      )}
                    </>
                  )}
                </div>
              </div>
            );
          })}
        </Paper>
      )}
    </div>
  );
};
